import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type DeleteTierInput = {
  programId: string;
  id: string;
};

// DELETE /api/admin/tiers/programs/:programId/tiers/:id
//
// Pessimistic. The service refuses deletion when partners are still assigned
// (returns a friendly count message that the toast renders directly).
// Cells cascade via FK ON DELETE CASCADE; partners.tier / tier_id cleanup
// is handled by the 0038 trigger on the unrelated assignment delete path,
// not by tier delete.
export function useDeleteTier() {
  const queryClient = useQueryClient();
  return useMutation<void, ApiClientError, DeleteTierInput>({
    mutationFn: ({ programId, id }) =>
      apiFetch<void>(`/admin/tiers/programs/${programId}/tiers/${id}`, {
        method: "DELETE",
      }),
    onSuccess: (_data, { programId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.tiers.program(programId) });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to delete tier");
    },
  });
}
